import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Pagination } from 'components/pagination/Pagination';
import { SubTitle } from 'components/text/SubTitle';
import { Typography, closeModal, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { Grid_3 } from 'modules/dashboard/styles/lesson';

import { isEmpty, orderBy } from 'lodash';

import { TABLE_KEY } from 'constants/table';

import { CardItem } from '../components/CardItem';
import { Header } from '../components/Header';
import { WarningNoDefault } from '../components/WarningNoDefault';
import { useAssessmentsController } from '../core/controller/assessments';
import { useLibrary } from '../core/hook';

const AssessmentsPage = () => {
  const {
    selectedAssessments,
    assessmentData,
    setSelectedAssessments,
    searchAssessment,
    onChangeSearchAssessment,
    onChangeSelectedAssessments,
    goToAssessmentDetail,
    handleDeleteAssessment,
    handleDuplicateAssessment,
    total,
    queryState,
    onDeleteAssessment,
    handleDelete,
    handleEditAssessment,
    isDefault,
  } = useAssessmentsController();

  const { onClickAddItem } = useLibrary();

  const selectedAssessmentTotal = Object.keys(selectedAssessments).length;

  const checkOnboardingAssessment = assessmentData
    .filter((el) => Object.keys(selectedAssessments).includes(el.id))
    .some((el) => el.isOnboarding);

  const showCheckbox = !isEmpty(Object.keys(selectedAssessments));

  const renderListFunctionalTest = () => {
    return (
      <>
        <Grid_3>
          {assessmentData.map((el, index) => {
            const selected = Boolean(selectedAssessments[el.id]);

            const orderByThumbnail = orderBy(el.functionalTests, 'index');

            return (
              <CardItem
                key={index}
                selected={selected}
                onChange={onChangeSelectedAssessments(el.id)}
                goToDetailPage={() => goToAssessmentDetail(el.id)}
                handleEdit={() => handleEditAssessment(el.id)}
                handleDelete={() => handleDeleteAssessment(el.id)}
                handleDuplicate={() => handleDuplicateAssessment(el.id)}
                hideAction={false}
                name={el.name}
                id={el.id}
                thumbnail={orderByThumbnail[0]?.thumbnail ?? ''}
                subTitle={
                  <div>
                    {el.isClass && el.isOnboarding ? (
                      <SubTitle leftTitle="Onboarding" rightTitle="Class" />
                    ) : (
                      <Typography
                        style={{ fontSize: '16px', lineHeight: '22px', color: '#808080' }}
                      >
                        {el.isClass
                          ? 'Class assessment'
                          : el.isOnboarding
                            ? 'Baseline fitness test'
                            : ''}
                      </Typography>
                    )}
                  </div>
                }
                showCheckbox={showCheckbox}
                isDefaultBFT={el.isDefault}
              />
            );
          })}
        </Grid_3>
        <Pagination total={total.value} queryState={queryState} tableKey={TABLE_KEY.ASSESSMENTS} />
      </>
    );
  };

  return (
    <div>
      <Header
        selected={selectedAssessments}
        options={assessmentData}
        setSelected={setSelectedAssessments}
        onDelete={() => openModal(MODAL_KEY.DELETE_ASSESSMENT)}
        type="assessment"
        searchValue={searchAssessment.value}
        onChangeSearch={onChangeSearchAssessment}
        onClickAddItem={onClickAddItem}
      />
      {!isDefault && <WarningNoDefault />}

      {assessmentData.length > 0 ? (
        renderListFunctionalTest()
      ) : (
        <Typography
          variant="h3"
          weight={700}
          style={{ textAlign: 'center', justifyContent: 'center', marginTop: 30 }}
        >
          No data
        </Typography>
      )}

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_ASSESSMENT}
        content={`${checkOnboardingAssessment ? `Without default baseline fitness test, Trainers will be unable to start baseline fitness tests on the mobile app.` : `Delete these ${selectedAssessmentTotal === 0 ? '' : selectedAssessmentTotal} assessments.`}`}
        header={`${checkOnboardingAssessment ? `Delete baseline fitness test` : `Delete ${selectedAssessmentTotal === 0 ? '' : selectedAssessmentTotal} assessments`}`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_ASSESSMENT)}
        onSubmit={() => {
          isEmpty(selectedAssessments) ? onDeleteAssessment() : handleDelete();
          closeModal(MODAL_KEY.DELETE_ASSESSMENT);
        }}
      />
    </div>
  );
};

export default AssessmentsPage;
